export const CRMTickets = [
  {
    id: 53,
    subject: "Test ticket",
    department: "Support",
    service: "General Support",
    contact: "Bharadwaj Ch",
    status: "Open",
    priority: "Low",
    last_reply: "No Reply Yet",
    created: "27/07/2023 11:38:06",
  },
  {
    id: 51,
    subject: "Attendance",
    department: "Support",
    service: "HR & Payroll",
    contact: "PV RAJU (PVR Spinning and Weaving Limited)",
    status: "Closed",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "16/06/2022 18:07:38",
  },
  {
    id: 50,
    subject: "Attendance",
    department: "Support",
    service: "Software",
    contact: "PV RAJU (PVR Spinning and Weaving Limited)",
    status: "Closed",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "16/06/2022 18:01:17",
  },
  {
    id: 49,
    subject: "Pvr Departments",
    department: "Support",
    service: "Company Operations",
    contact: "PV RAJU (PVR Spinning and Weaving Limited)",
    status: "Open",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "16/06/2022 16:59:38",
  },
  {
    id: 48,
    subject: "Leave mail alerts are not coming",
    department: "Support",
    service: "Email & Notifications",
    contact: "Ravikiran Veluri (VAG-Valves (India) Pvt Ltd)",
    status: "Closed",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "30/05/2022 19:06:37",
  },
  {
    id: 47,
    subject: "PaySlips for two employees",
    department: "Support",
    service: "HR & Payroll",
    contact: "Raju . (Sri Sai Transporters)",
    status: "Open",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "30/05/2022 19:04:59",
  },
  {
    id: 46,
    subject: "Rate Change for 2 Employees",
    department: "Support",
    service: "HR & Payroll",
    contact: "Bipin Shah (Texplast Industries Limited)",
    status: "Open",
    priority: "Medium",
    last_reply: "No Reply Yet",
    created: "30/05/2022 18:51:16",
  },
];
